/**
 * GET /api/desk/phone-lookup?phone=…&dispatcherId=… — «Найти номер» на пульте
 * (24.09.2026, решение Evgeniy).
 *
 * Таня: «перезвоны улетают, и их потом не найти». Ответ говорит, где номер
 * сейчас и почему, и что по нему делал сам диспетчер. Свой перезвон (state
 * my_callback) пульт забирает тем же POST /desk/callbacks/:id/take, что и блок
 * «Перезвоны», — по queueItemId из этого ответа.
 *
 * Номер приходит как его набрал человек: «8 928 256-09-56», «+7…», «928…».
 * Нормализует сервер той же функцией, что и приём (§6.8). dispatcherId — как у
 * снапшота: админ и супервизор ищут глазами наблюдаемого диспетчера.
 *
 * Время — ISO: МСК форматирует пульт. Имён других диспетчеров в ответе нет.
 */
import { z } from 'zod';
import { assignmentStatusSchema, bigIdSchema, isoDateTimeSchema, phoneE164Schema, } from './common.dto.js';
export const deskPhoneLookupQuerySchema = z.object({
    phone: z.string().max(32),
    dispatcherId: bigIdSchema.optional(),
});
/**
 * Где номер сейчас:
 *  - my_callback — договорённость диспетчера ждёт своего времени (можно позвонить сейчас);
 *  - my_card — карточка уже на его пульте;
 *  - my_next_round — ждёт у него следующего круга;
 *  - other — у другого диспетчера;
 *  - pool — в общей очереди;
 *  - robot — у робота (reason — почему);
 *  - closed — закрыт (reason — чем).
 */
export const deskPhoneLookupStateSchema = z.enum([
    'my_callback',
    'my_card',
    'my_next_round',
    'other',
    'pool',
    'robot',
    'closed',
]);
export const deskPhoneLookupResponseSchema = z.discriminatedUnion('found', [
    /** Номера нет среди выданных этому диспетчеру: чужой и несуществующий неотличимы */
    z.object({ found: z.literal(false), phone: phoneE164Schema }),
    z.object({
        found: z.literal(true),
        phone: phoneE164Schema,
        fullName: z.string().nullable(),
        queueItemId: bigIdSchema,
        state: deskPhoneLookupStateSchema,
        /** Почему номер там, где он есть, словами для человека; null — объяснять нечего */
        reason: z.string().nullable(),
        /** Срок перезвона, начало круга, уход к роботу или закрытие; null — момента нет */
        at: isoDateTimeSchema.nullable(),
        /** О чём договорились — только у перезвона */
        comment: z.string().nullable(),
        /** Свои назначения по номеру, новые первыми, не больше 20 */
        history: z.array(z.object({
            assignmentId: bigIdSchema,
            assignedAt: isoDateTimeSchema,
            status: assignmentStatusSchema,
            labelTitle: z.string().nullable(),
            comment: z.string().nullable(),
            nextActionAt: isoDateTimeSchema.nullable(),
            callsCnt: z.number().int().min(0),
            talkSec: z.number().int().min(0),
        })),
    }),
]);
//# sourceMappingURL=desk-phone-lookup.dto.js.map